import angular from 'angular';
import downloadHtmlToImgMenu from './downloadHtmlToImgMenu';
import './style.scss';

export default angular
  .module('components.downloadHtmlToImgMenu', [])
  .component('downloadHtmlToImgMenu', downloadHtmlToImgMenu).name;
